import { Component, OnInit } from '@angular/core';
import { EquipmentService } from '../../equipments/equipment-service/equipment.service';
import { sweetAlert } from 'src/app/utils/swal';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';

@Component({
  selector: 'app-addon-list',
  templateUrl: './addon-list.component.html',
  styleUrls: ['./addon-list.component.css']
})
export class AddonListComponent implements OnInit {

  search;
  addons =[];
  user;
  status = "active";
  preCooperates = {};
  preSpaceTypes= {};

  constructor(
    private equipmentService: EquipmentService,
    private corporateService: CorporateService,
    private levelOfServiceService: LevelOfServiceService
  ) { }

  ngOnInit() {
    this.getEquipments();
    this.getSpaceTypes();
  }

  getEquipments() {
    let queryParams = {
      isAddon: true
    }
      this.equipmentService
        .getEquipments(queryParams)
        .subscribe(data => {
          if (data && data.length) {
            this.addons = data;
          }else{
            this.addons = [];
          }
        }, err => {
          sweetAlert("Error", err, "error", "Ok");
        });
        this.getFundingSourceList();
  }

  getFundingSourceList() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data ) {
          this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});   
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }
  
  ngOnDestroy(): void {
  }

}
